import { useEffect, useRef } from 'react'

function useDebounceCallback<T extends (...args: any[]) => any>(
  callback: T,
  delay: number
): (...args: Parameters<T>) => void {
  const ref = useRef<NodeJS.Timeout | undefined>(undefined)

  useEffect(() => {
    return () => {
      if (ref.current) {
        clearTimeout(ref.current)
      }
    }
  }, [])

  return useRef((...args: Parameters<T>) => {
    if (ref.current) {
      clearTimeout(ref.current)
    }

    ref.current = setTimeout(() => {
      callback(...args)
    }, delay)
  }).current
}

export default useDebounceCallback
